export default {
    patientData : "",
};
